import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-smooth-collapse';
import cn from 'classnames';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import Tooltip from '@omilia/tooltip';
import TextCropper from '@omilia/text-cropper';
import Highlighter from 'react-highlight-words';
import { colors } from '@omilia/theme';

import Toggler from 'components/Toggler';
import { ruleType } from 'types';
// eslint-disable-next-line import/no-named-as-default-member
import RuleHOC from '../RuleHOC';
import RuleItem from '../RuleItem';
import RuleGroupActionsMenu from './components/RuleGroupActionsMenu';

import './style.scss';

export class RuleGroupItem extends Component {
  static propTypes = {
    isPreSelected: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    model: ruleType.isRequired,
    canDrop: PropTypes.bool,
    fullGroups: PropTypes.arrayOf(ruleType),
    getRuleMatchedRows: PropTypes.func,
    groupIsDragged: PropTypes.bool,
    isArchived: PropTypes.bool,
    isDragging: PropTypes.bool,
    isOver: PropTypes.bool,
    matchedRulesMap: PropTypes.shape({}),
    moveRuleToGroup: PropTypes.func,
    number: PropTypes.node,
    partialUpdateRule: PropTypes.func,
    reorder: PropTypes.node,
    reorderGroupItem: PropTypes.func,
    searchTerm: PropTypes.string,
    selectedGroupItem: ruleType,
    selectGroupItem: PropTypes.func,
    statusChange: PropTypes.func,
    toggleItemStatus: PropTypes.func,
    onExpanded: PropTypes.func,
    onOpenAddRuleModal: PropTypes.func,
    onOpenDeleteModal: PropTypes.func,
    onOpenDuplicateModal: PropTypes.func,
  };

  state = {
    isHovered: false,
    isExpanded: false,
    isActionsMenuOpened: false,
  };

  componentWillReceiveProps(nextProps) {
    const { isSelected } = this.props;
    const { isSelected: isSelectedNext } = nextProps;
    const { isHovered } = this.state;
    if (isSelectedNext !== isSelected && isHovered) {
      this.setState({
        isHovered: false,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      isSelected,
      isPreSelected,
      isOver,
      canDrop,
      model,
      reorder,
      number,
    } = this.props;
    const { isHovered, isActionsMenuOpened, isExpanded } = this.state;
    const {
      isSelected: isSelectedNext,
      isPreSelected: isPreSelectedNext,
      isOver: isOverNext,
      canDrop: canDropNext,
      model: modelNext,
      reorder: reorderNext,
      number: numberNext,
    } = nextProps;
    const {
      isHovered: isHoveredNext,
      isActionsMenuOpened: isActionsMenuOpenedNext,
      isExpanded: isExpandedNext,
    } = nextState;
    return (
      isSelected !== isSelectedNext ||
      isPreSelected !== isPreSelectedNext ||
      isHovered !== isHoveredNext ||
      isActionsMenuOpened !== isActionsMenuOpenedNext ||
      isExpanded !== isExpandedNext ||
      isOver !== isOverNext ||
      canDrop !== canDropNext ||
      !_isEqual(modelNext, model) ||
      !_isEqual(reorderNext, reorder) ||
      !_isEqual(numberNext, number)
    );
  }

  handleOpenActionsMenu = e => {
    e.stopPropagation();

    this.setState(({ isActionsMenuOpened }) => ({
      isActionsMenuOpened: !isActionsMenuOpened,
    }));
  };

  handleCloseActionsMenu = () => {
    this.setState({
      isActionsMenuOpened: false,
    });
  };

  handleToggleCollapsible = e => {
    e.stopPropagation();
    const { model, onExpanded } = this.props;
    const { isExpanded } = this.state;

    if (model.rules.length) {
      this.setState(
        prevState => ({
          isExpanded: !prevState.isExpanded,
        }),
        onExpanded(isExpanded),
      );
    }
  };

  handleMouseEnter = () => {
    const { isSelected } = this.props;

    if (!isSelected) {
      this.setState({
        isHovered: true,
      });
    }
  };

  handleMouseLeave = () => {
    const { isSelected } = this.props;

    if (!isSelected) {
      this.setState({
        isHovered: false,
      });
    }
  };

  handleRefWrap = reorder => {
    this.reorder = reorder;
  };

  handleDelete = () => {
    const { onOpenDeleteModal, model } = this.props;

    onOpenDeleteModal(model.id, model.name);
  };

  handleSelected = item => {
    const { selectedGroupItem } = this.props;

    return _get(selectedGroupItem, 'id') === item.id;
  };

  handleOpenAddRuleModal = () => {
    const {
      onOpenAddRuleModal,
      model: { rules, id, order },
    } = this.props;
    onOpenAddRuleModal(id, rules.length, order);
  };

  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  renderDetails() {
    const {
      model: { rules, enabled },
      model,
      statusChange,
    } = this.props;

    const { isActionsMenuOpened } = this.state;

    return (
      <div styleName="hover-block">
        {rules.length > 0 && (
          <Tooltip content={`${enabled ? 'Deactivate' : 'Activate'} Group`}>
            <div data-test="status" styleName="status">
              <Toggler value={enabled} onToggle={statusChange} />
            </div>
          </Tooltip>
        )}

        <div
          data-test="delete"
          styleName={cn('delete-block', {
            pointer: isActionsMenuOpened,
          })}
        >
          <span
            className="icon-options rule"
            onClick={this.handleOpenActionsMenu}
          />
          {isActionsMenuOpened && (
            <RuleGroupActionsMenu
              model={model}
              onClose={this.handleCloseActionsMenu}
              onOpenAddModal={this.handleOpenAddRuleModal}
              onOpenDeleteModal={this.handleDelete}
            />
          )}
        </div>
      </div>
    );
  }

  renderGroup() {
    const {
      model,
      number,
      reorder,
      isArchived,
      isSelected,
      searchTerm,
    } = this.props;
    const { isHovered, isExpanded, isActionsMenuOpened } = this.state;
    const { name, rules, enabled } = model;
    const renderLength = rules.length || 'empty';

    return (
      <div
        ref={this.handleRefWrap}
        data-test="rule-group-item"
        styleName={cn('item', {
          'is-expanded': isExpanded,
          'is-disabled': !enabled,
        })}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div styleName="name-block">
          {number}
          <span
            className={cn({
              'icon-triangle-arrow-down': isExpanded,
              'icon-triangle-arrow-up': !isExpanded,
            })}
            data-test="toggle-rule-group-icon"
            styleName={cn('caret', {
              'is-disabled': !rules.length,
            })}
            onClick={this.handleToggleCollapsible}
          />
          <div data-test="rule-group-name" styleName="name">
            <span className="icon-rule-group rule" />
            <div styleName="crooper-container">
              <TextCropper styleName="cropper">
                <Highlighter
                  autoEscape
                  highlightClassName="text-highlighter"
                  highlightStyle={{ color: colors.COLOR_GREY_900 }}
                  highlightTag="strong"
                  searchWords={[searchTerm?.trim()]}
                  textToHighlight={name}
                />
                <span
                  data-test="number-of-rules"
                  styleName={cn('amount', {
                    'is-filled': model.rules.length > 0,
                  })}
                >
                  ( {renderLength} )
                </span>
              </TextCropper>
            </div>
          </div>
        </div>
        {!isArchived &&
          (isSelected || isHovered || isActionsMenuOpened) &&
          this.renderDetails()}
        {reorder}
      </div>
    );
  }

  render() {
    const {
      model,
      isArchived,
      isSelected,
      isPreSelected,
      statusChange,
      matchedRulesMap,
      getRuleMatchedRows,
      selectGroupItem,
      reorderGroupItem,
      toggleItemStatus,
      onOpenDuplicateModal,
      isOver,
      canDrop,
      moveRuleToGroup,
      fullGroups,
      isDragging,
      groupIsDragged,
      partialUpdateRule,
      searchTerm,
    } = this.props;
    const { isHovered, isExpanded } = this.state;
    const isDragged = isOver && canDrop && !isDragging;
    const empty =
      (model.rules.length === 0 || !isExpanded) &&
      !groupIsDragged &&
      !model.archived;
    return (
      <div
        styleName={cn('group', {
          'is-archived': isArchived,
          'is-disabled': false,
          'is-pre-selected': isPreSelected || isHovered,
          'is-selected': isSelected,
          'is-empty': model.rules.length === 0,
          'is-dragging': isDragging,
          'is-over': isDragged && !empty,
          'is-over-empty': isDragged && empty,
          // 'not-dropped': isOver && !canDrop,
        })}
      >
        {this.renderGroup()}
        <Collapsible expanded={isExpanded} styleName="block">
          {model.rules.map(item => {
            const selected = this.handleSelected(item);
            return (
              <RuleItem
                key={item.id}
                isGrouped
                count={model.rules.length}
                fullGroups={fullGroups}
                getRuleMatchedRows={getRuleMatchedRows}
                index={model.order}
                isArchived={item.archived}
                isPreSelected={selected}
                isSelected={selected}
                matchedRulesMap={matchedRulesMap}
                model={item}
                moveRuleToGroup={moveRuleToGroup}
                partialUpdateItem={partialUpdateRule}
                reorderItem={reorderGroupItem}
                searchTerm={searchTerm}
                selectGroupItem={selectGroupItem}
                statusChange={statusChange}
                styleName="block-item"
                toggleItemStatus={toggleItemStatus}
                onOpenDuplicateModal={onOpenDuplicateModal}
              />
            );
          })}
        </Collapsible>
      </div>
    );
  }
}

export default RuleHOC(RuleGroupItem);
